/* eslint-disable react/no-multi-comp */
// @ts-ignore
import { Field } from "redux-form/dist/redux-form";
import type { BaseFieldProps, WrappedFieldProps } from "redux-form";

import TextArea, { type TextAreaProps } from "./TextArea";
import { generateFieldId, returnFieldState } from "./formMetaHelpers";


type TextAreaFieldProps = TextAreaProps & WrappedFieldProps;

function TextAreaField({
  meta,
  input,
  disabled,
  fieldProps = {},
  ...textareaProps
}: TextAreaFieldProps) {

  const id = generateFieldId("textarea", meta, textareaProps, input);
  const { isInvalid, isValid } = returnFieldState(meta);

  return (
    <TextArea
      id={id}
      fieldProps={fieldProps}
      value={input.value}
      onChange={input.onChange}
      onFocus={input.onFocus}
      onBlur={input.onBlur}
      isInvalid={isInvalid}
      isValid={isValid}
      errorMessage={meta.error}
      name={input.name}
      disabled={meta.submitting || disabled}
      {...textareaProps} />
  );
}

type TextAreaFieldHocProps = TextAreaProps & BaseFieldProps;

function FieldHoc(props: TextAreaFieldHocProps) {

  return (
    <Field
      component={TextAreaField}
      {...props} />
  );
}

FieldHoc.TextArea = TextAreaField;
export default FieldHoc;
